import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DynamicBarComponent} from './dynamic-bar.component';
import { GlmBarrasModule } from '../glm-barras/glm-barras.module';

@NgModule({
    imports: [
      CommonModule,
      GlmBarrasModule,
    ],
    exports: [DynamicBarComponent],
    declarations: [DynamicBarComponent],
})
export class DynamicBarModule {
}
